import * as yup from 'yup';

const dateRegex = /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
const currencyRegex = /^\d{1,},\d{2}$/;

yup.addMethod(yup.string, 'select', function () {
  return this.test('select', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && field.value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

yup.addMethod(yup.string, 'date', function () {
  return this.test('date', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && dateRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid date' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'currency', function () {
  return this.test('currency', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && currencyRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid currency' }));
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  color: yup
    .string()
    .required()
    .trim(),
  specie: yup.string().select(),
  breed: yup.string().select(),
  born: yup.string().date(),
  gender: yup
    .string()
    .required()
    .trim(),
  size: yup
    .string()
    .required()
    .trim(),
  weight: yup.string().currency()
});

export default schema;
